module.exports = __webpack_public_path__ + "static/img/pic_toptitlle_cpraed@2x.9b4a32b8.png";